// TODO: MNS-2360 - Can be removed after the entire create order form is migrated to React.
import { AddClientModal } from './AddClientModal'

export default AddClientModal
